import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { CompareSeatCard } from './CompareSeatCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CARD_WIDTH = 312;
const CARD_GAP = 24;
const MODAL_PADDING = 80;
const PRODUCT_CATALOG_URL = 'https://legal.hubspot.com/hubspot-product-and-services-catalog#HubSpotSeats';
export function CompareSeatsModal({
  isOpen,
  isLoading,
  seatCards,
  currencyCode,
  onOpen,
  onClose
}) {
  const modalWidth = CARD_WIDTH * seatCards.length + CARD_GAP * (seatCards.length - 1) + MODAL_PADDING;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: onOpen,
      "data-selenium-id": "compare-seats-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "compareSeats.trigger"
      })
    }), isOpen && /*#__PURE__*/_jsxs(Modal, {
      width: modalWidth,
      dialogStyles: {
        maxInlineSize: '100%'
      },
      onEsc: onClose,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "compareSeats.title"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        paddingBlockStart: "600",
        paddingBlockEnd: "300",
        children: isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
          size: "medium",
          layout: "centered"
        }) : /*#__PURE__*/_jsx(Flex, {
          flexWrap: "wrap",
          gap: "600",
          justifyContent: "center",
          children: seatCards.map(card => /*#__PURE__*/_jsx(CompareSeatCard, {
            card: card,
            currencyCode: currencyCode
          }, card.apiName))
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        borderBlockStartWidth: "100",
        borderBlockStartStyle: "solid",
        borderBlockStartColor: "border-container-default",
        children: /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          external: true,
          href: PRODUCT_CATALOG_URL,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "compareSeats.seeFullProductCatalog"
          })
        })
      })]
    })]
  });
}